// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-level-section,
.listing-browse-landing-section {
  padding: 60px 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 248, 248, 0.95) 100%);
  min-height: 700px;
  position: relative;
}
.category-level-section::before,
.listing-browse-landing-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(212, 175, 55, 0.02) 0%, transparent 100%);
  pointer-events: none;
}

.category-group {
  margin-bottom: 40px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(212, 175, 55, 0.1);
}

.group-title {
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 300;
  font-size: 22px;
  color: #2d2d2d;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
  position: relative;
}
.group-title::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 60px;
  height: 2px;
  background: #d4af37;
}

.category-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-decoration: none;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
  color: inherit;
}
.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border-color: rgba(212, 175, 55, 0.3);
}
.category-card > a {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  text-decoration: none;
  color: inherit;
}
.category-card.featured {
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%);
  border: 1px solid rgba(212, 175, 55, 0.2);
}
.category-card.featured .card-content h4 {
  color: #d4af37;
}
.category-card.service-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 240, 240, 0.8) 100%);
}
.category-card.brand-card {
  padding: 16px;
}
.category-card.brand-card .card-icon {
  margin-bottom: 12px;
}
.category-card.brand-card .card-content h4 {
  font-size: 14px;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(212, 175, 55, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}
.card-icon app-category-visual {
  width: 100%;
  height: 100%;
}
.card-icon img {
  transition: transform 0.3s ease;
}

.category-card:hover .card-icon {
  background: rgba(212, 175, 55, 0.1);
  border-color: rgba(212, 175, 55, 0.3);
}
.category-card:hover .card-icon img,
.category-card:hover .card-icon ::ng-deep .category-visual-photo {
  transform: scale(1.05);
}

.card-content {
  text-align: center;
}
.card-content h4 {
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #2d2d2d;
  margin-bottom: 4px;
}
.card-content p {
  color: #666;
  font-size: 13px;
  margin: 0;
  font-weight: 300;
}

.icon svg {
  width: 48px;
  height: 48px;
  fill: #333;
}

@media (max-width: 768px) {
  .category-level-section,
  .listing-browse-landing-section {
    padding: 40px 0;
  }
  .category-card {
    padding: 16px 12px;
  }
  .card-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 12px;
  }
  .card-content h4 {
    font-size: 14px;
  }
}
.card-icon-centered {
  margin-left: auto;
  margin-right: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/category/shared/_category-picker.scss","webpack://./src/app/category/shared/category-level/category-level.component.scss"],"names":[],"mappings":"AACA;;EAEE,eAAA;EACA,iGAAA;EACA,iBAAA;EACA,kBAAA;ACAF;ADEE;;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iFAAA;EACA,oBAAA;ACCJ;;ADGA;EACE,mBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,0CAAA;EACA,yCAAA;ACAF;;ADGA;EACE,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,kBAAA;ACAF;ADEE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;ACAJ;;ADIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,qCAAA;EACA,cAAA;ACDF;ADGE;EACE,2BAAA;EACA,yCAAA;EACA,qCAAA;ACDJ;ADIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;ACFJ;ADKE;EACE,+FAAA;EACA,yCAAA;ACHJ;ADKI;EACE,cAAA;ACHN;ADOE;EACE,gGAAA;ACLJ;ADQE;EACE,aAAA;ACNJ;ADQI;EACE,mBAAA;ACNN;ADSI;EACE,eAAA;ACPN;;ADYA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;ACTF;ADWE;EACE,WAAA;EACA,YAAA;ACTJ;ADYE;EACE,+BAAA;ACVJ;;ADcA;EACE,mCAAA;EACA,qCAAA;ACXF;ADaE;;EAEE,sBAAA;ACXJ;;ADeA;EACE,kBAAA;ACZF;ADcE;EACE,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ACZJ;ADeE;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;ACbJ;;ADiBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;ACdF;;ADiBA;EACE;;IAEE,eAAA;ECdF;EDiBA;IACE,kBAAA;ECfF;EDkBA;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EChBF;EDmBA;IACE,eAAA;ECjBF;AACF;AApKA;EACE,iBAAA;EACA,kBAAA;AAsKF;;AAnKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAsKF;;AAnKA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAsKF;;AAnKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAsKF;;AAnKA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAsKF;;AAnKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAsKF;;AAnKA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAsKF","sourcesContent":["// Shared taxonomy picker layout (top-level browse landing + drill-down levels).\n.category-level-section,\n.listing-browse-landing-section {\n  padding: 60px 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 248, 248, 0.95) 100%);\n  min-height: 700px;\n  position: relative;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(45deg, rgba(212, 175, 55, 0.02) 0%, transparent 100%);\n    pointer-events: none;\n  }\n}\n\n.category-group {\n  margin-bottom: 40px;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(212, 175, 55, 0.1);\n}\n\n.group-title {\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  font-weight: 300;\n  font-size: 22px;\n  color: #2d2d2d;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(212, 175, 55, 0.2);\n  position: relative;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 60px;\n    height: 2px;\n    background: #d4af37;\n  }\n}\n\n.category-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 16px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  text-decoration: none;\n  height: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  color: inherit;\n\n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n    border-color: rgba(212, 175, 55, 0.3);\n  }\n\n  > a {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1;\n    width: 100%;\n    text-decoration: none;\n    color: inherit;\n  }\n\n  &.featured {\n    background: linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%);\n    border: 1px solid rgba(212, 175, 55, 0.2);\n\n    .card-content h4 {\n      color: #d4af37;\n    }\n  }\n\n  &.service-card {\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 240, 240, 0.8) 100%);\n  }\n\n  &.brand-card {\n    padding: 16px;\n\n    .card-icon {\n      margin-bottom: 12px;\n    }\n\n    .card-content h4 {\n      font-size: 14px;\n    }\n  }\n}\n\n.card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  margin-bottom: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(212, 175, 55, 0.1);\n  transition: all 0.3s ease;\n  overflow: hidden;\n\n  app-category-visual {\n    width: 100%;\n    height: 100%;\n  }\n\n  img {\n    transition: transform 0.3s ease;\n  }\n}\n\n.category-card:hover .card-icon {\n  background: rgba(212, 175, 55, 0.1);\n  border-color: rgba(212, 175, 55, 0.3);\n\n  img,\n  ::ng-deep .category-visual-photo {\n    transform: scale(1.05);\n  }\n}\n\n.card-content {\n  text-align: center;\n\n  h4 {\n    font-family: 'Helvetica Neue', Arial, sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    color: #2d2d2d;\n    margin-bottom: 4px;\n  }\n\n  p {\n    color: #666;\n    font-size: 13px;\n    margin: 0;\n    font-weight: 300;\n  }\n}\n\n.icon svg {\n  width: 48px;\n  height: 48px;\n  fill: #333;\n}\n\n@media (max-width: 768px) {\n  .category-level-section,\n  .listing-browse-landing-section {\n    padding: 40px 0;\n  }\n\n  .category-card {\n    padding: 16px 12px;\n  }\n\n  .card-icon {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 12px;\n  }\n\n  .card-content h4 {\n    font-size: 14px;\n  }\n}\n","@use '../category-picker';\n\n.card-icon-centered {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
